import React, { useState } from 'react';
import { SelectableList } from './SelectableList';
import { Button } from '../Button/Button';

export function SelectableListExample(): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Button title="Toggle selectable list" onClick={() => setOpen(!open)} />
      {open && (
        <SelectableList
          options={['Option 1', 'Option 2', 'Option 3']}
          onSelect={(option) => {
            alert(option);
          }}
        />
      )}
    </div>
  );
}
